import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7ca0b20b-418e-44ac-a9da-3db548a8f509/artifacts/eb1jluni_antropia_logo_voice_measurement_symbol_and_text_1775847083138.png";

const footerLinks = [
  {
    title: "Legal",
    links: [
      { href: "/terminos-y-condiciones", label: "Términos y Condiciones" },
      { href: "/politica-privacidad", label: "Política de Privacidad" },
      { href: "/uso-aceptable", label: "Uso Aceptable" },
      { href: "/procesamiento-de-datos", label: "Procesamiento de Datos" },
    ],
  },
  {
    title: "Empresa",
    links: [
      { href: "/nosotros", label: "Nosotros" },
      { href: "mailto:contacto@antropia.app", label: "Contacto" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-black/50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo and description */}
          <div className="md:col-span-2">
            <Link to="/" data-testid="footer-logo">
              <img 
                src={LOGO_URL} 
                alt="Antropia" 
                className="h-10 w-auto mb-6"
              />
            </Link>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-md">
              Tu segundo cerebro para consultas nutricionales. Graba, analiza y documenta 
              automáticamente con IA. Más tiempo para tu cliente, cero esfuerzo mental.
            </p>
          </div>

          {/* Links */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-semibold text-white mb-4 font-outfit">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-zinc-500 hover:text-[#E05D3A] transition-colors text-sm"
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-600 text-sm">
            © {new Date().getFullYear()} Antropia. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <motion.div
              className="flex items-center gap-2 text-zinc-500 text-sm"
              animate={{ opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <span className="w-2 h-2 bg-green-500 rounded-full"></span>
              Todos los sistemas operativos
            </motion.div>
          </div>
        </div>
      </div>
    </footer>
  );
};
